import React, { Component } from "react";
import {
    Form,
    Select,
    DatePicker,
    Input,
    message,
    Table,
    Button,
    Space,
    Row,
    Col,
    Modal,
    Tooltip,
    Spin,
} from "antd";
import ResizableTable from "./ResizableTable";

import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";
import { DeleteFilled, PlusOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import withRouter from "../withRouter";
import config from "../config";
import CompanyAutocomplete from "./CompanyAutocomplete";
import CompanyStore from "../store/CompanyStore";
import NewMaintenanceStore from "../store/NewMaintenanceStore";
import SensorListStore from "../store/SensorListStore";
const { Option } = Select;
const { Column } = Table;
class AddSensors extends Component {
    formRef = React.createRef();
    driverformRef = React.createRef();
    mainFormRef = React.createRef();
    serviceFormRef = React.createRef();
    constructor(props, context) {
        super(props);

        this.state = {
            loading: false,
            tableData: [],
            companyId: "",
            loadList: 0,
            vehicleId: "",
            serviceData: [],
            companyId: "",
            Id: -1,
            listUpdated: 0,
            formLoading: false,
            pageSize: 50,
            currentPage: 0,
            filterData: [],
            sid: 1,
            loadingData: false,


        };

        this.newMainStore = new NewMaintenanceStore(this);
        this.companyStore = new CompanyStore();
        this.senesorListStore = new SensorListStore();
    }

    layout = {
        labelCol: { span: 8 },
        wrapperCol: { span: 16 },
    };
    handleResize =
        (index) =>
            (_, { size }) => {
                this.setState((prevState) => {
                    if (!Array.isArray(prevState.columns)) return null;

                    const newColumns = [...prevState.columns];
                    newColumns[index] = { ...newColumns[index], width: size.width };

                    return { columns: newColumns };
                });
            };

    async componentDidMount() {

        if (
            Number(this.props.getUserData().isadmin) !== -1 &&
            Number(this.props.getUserData().isadmin) !== 3
        ) {
            this.context.viewStateStore.setSensorStates({
                companyId: this.props.getUserData().userCompanyId,
            });
            await this.setState({
                companyId: this.props.getUserData().userCompanyId,
            });
        }

        await this.setState({ loadList: 1 });

        const Id = this.props.id;

        if (Id) {

            await this.filldata(Id);
            this.setState({ Id: Id });
        }
    }

    filldata = async (Id) => {
        await this.setState({ loadingData: true });
        const isadmin = Number(this.props.getUserData().isadmin)
        const userId = Number(this.props.getUserData().userId)

        const getSensordata = await this.senesorListStore.getSensorData({
            offset: 0,
            limit: 1,
            companyId: this.props.companyId,
            Id: Id,
            isadmin: isadmin,
            userId: userId
        });
        await this.setState({
            companyId: getSensordata.companyId,
            vehicleId: getSensordata.vehicleId
        });
        const singleData = await this.companyStore.getCompanyDataById(
            getSensordata.companyId
        );

        await this.senesorListStore.getAssignAsset({
            companyId: this.props.companyId,
        });

        await this.getSensors(getSensordata.vehicleId);

        const data2 = await this.senesorListStore.getSensorDatabyVehicleId(getSensordata.vehicleId);
        const newRecord = data2.map((detail) => ({
            // const newRecord = {
            sid: detail.sid,
            Id: detail.Id,
            vehicleId: detail.vehicleId,
            calibrationFactor: detail.calibrationFactor,
            humidityCalFactor: detail.humidityCalFactor,
            sensorId: detail.sensorId,
            sensorName: detail.sensorName,
            vehicleNo: detail.vehicleNo
        }));
        this.setState({ sid: newRecord.length + 1 });
        await this.setState({ tableData: newRecord });

        this.setState({ loadingData: false });


        await this.formRef.current.setFieldsValue({
            companyId: singleData,

        });
        this.setState({ loading: false });
    };
    onSensorSubmit = async (values) => {
        this.setState({ loading: true });
        const data = {
            tokenId: "",
            companyId: this.state.companyId,
            GridDetails: this.state.tableData,
        };

        const { tableData } = this.state;

        const vehicleSensorMap = {};
        let isValid = true;

        for (let i = 0; i < tableData.length; i++) {
            const vehicleId = String(tableData[i].vehicleId).trim();
            const sensorId = String(tableData[i].sensorId).trim();

            if (!vehicleSensorMap[vehicleId]) {
                vehicleSensorMap[vehicleId] = new Set();
            }

            if (vehicleSensorMap[vehicleId].has(sensorId)) {
                isValid = false;

                message.error(
                    `SensorId Already Assigned.`
                );

                break;
            }

            vehicleSensorMap[vehicleId].add(sensorId);
        }
        if (!isValid) {
            return;
        }


        console.log(data)
        const resp = await this.senesorListStore.addData(data);
        await this.props.response(resp);

        this.setState({ loading: false });
    };

    handleInputChange = (e, index, fieldName) => {

        const newData = [...this.state.tableData];
        if (fieldName === "vehicleId" || fieldName === "sensorId") {
            newData[index][fieldName] = e;
        } else {
            newData[index][fieldName] = e.target.value;
        }
    };

    handleAddRecord = () => {
        this.setState((prevState) => {
            const newRecord = {
                sid: prevState.sid, // use current ID
                Id: -1,
                vehicleId: '',
                sensorId: '',
                sensorName: '',
                calibrationFactor: '',
                humidityCalFactor: ''
            };
            return {
                sid: prevState.sid + 1,
                tableData: [...prevState.tableData, newRecord],
            };
        });
    };
    onDeleteRow = (index) => {
        const filterData = this.state.tableData
            .filter((val, ind) => ind !== index)
            .map((row, i) => ({
                ...row,
                sid: i + 1,
            }));

        this.setState({
            tableData: filterData,
            sid: filterData.length + 1,
        });
    };
    async handleChange(comp) {
        await this.setState({ companyId: comp.value });
        await this.formRef.current.setFieldsValue({
            companyId: this.state.companyId,
        });
        if (!this.props.id) {
            this.context.viewStateStore.setSensorStates({
                companyId: comp.value,
            });
        }
        const singleData = await this.companyStore.getCompanyDataById(comp.value);
        await this.setState({ company_value_label: singleData });


        await this.senesorListStore.getAssignAsset({
            companyId: comp.value,
        });

        this.setState({ update: 1 });
    }


    closeModal = () => {
        this.props.closeModal();
    };

    getSensors = async (val) => {
        const data = await this.senesorListStore.getSensors(val);

        this.setState({ loadData: 1 });
    };


    render() {

        return (
            <div style={{ padding: 0 }}>
                <div style={{ paddingBottom: "10px" }}>
                    <Spin spinning={this.state.loadingData} fullscreen>
                        <Form
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                height: "100%",
                                // overflow: "auto",
                            }}
                            layout="vertical"
                            ref={this.formRef}
                            onFinish={this.onSensorSubmit}
                            className="formClass" //change
                            name="nest-message"
                        >
                            <Row  >
                                <Col span={24} className="formColumnClass">
                                    {(this.props.getUserData().isadmin === -1 ||
                                        this.props.getUserData().isadmin === 3) && (
                                            <Form.Item
                                                name="companyId"
                                                label={this.context.translate("_ACCOUNT_")}
                                                rules={[{ required: true }]}
                                            >
                                                <CompanyAutocomplete
                                                    onChange={(value) => {
                                                        this.handleChange(value);
                                                        this.formRef.current.setFieldsValue({
                                                            vehicleId: undefined,
                                                        });
                                                    }}
                                                    style={{ width: "100%" }}
                                                />
                                            </Form.Item>
                                        )}
                                </Col>
                                <Col span={24}>
                                    <Row>
                                        <Button
                                            type="primary"
                                            onClick={this.handleAddRecord}
                                            style={{ margin: "10px 0px 20px 0px" }}
                                        >
                                            {this.context.translate("_ADD_SENSOR_")}
                                        </Button>
                                    </Row>
                                    <Table
                                        style={{ marginInlineEnd: "10px" }}
                                        dataSource={this.state.tableData}
                                        scroll={{ y: 260 }}
                                        bordered
                                    >
                                        {false && (<Column
                                            title={this.context.translate("_Id_")}
                                            dataIndex="sid"
                                            key="sid"
                                            render={(text, record, index) => (
                                                <Input
                                                    value={text}
                                                    onChange={(e) =>
                                                        this.handleInputChange(e, index, "sid")
                                                    }
                                                />
                                            )}
                                        />)}
                                        <Column
                                            title={this.context.translate("_VEHICLE_")}
                                            dataIndex="vehicleId"
                                            key="vehicleId"
                                            width={100}
                                            render={(text, record, index) => (
                                                <Select
                                                    style={{ width: "150px" }}
                                                    value={text}
                                                    onSelect={async (e, f) => {
                                                        console.log(f)
                                                        console.log(index)
                                                        this.setState({ vehicleId: e });
                                                        await this.handleInputChange(e, index, "vehicleId");
                                                        if (this.state.Id == -1 || e != this.state.vehicleId) {
                                                            var getSensordata = await this.senesorListStore.getSensorDatabyVehicleId(e, index);
                                                            if (getSensordata.length > 0) {
                                                                message.error("Record already exists for this vehicle.Edit the record to add new sensor.")
                                                                this.onDeleteRow(index);
                                                                return;
                                                            }
                                                        }
                                                        await this.getSensors(e);
                                                    }}
                                                    fieldNames={{
                                                        value: "vehicleId",
                                                        label: "vehicleNo",
                                                    }}
                                                    showSearch
                                                    optionFilterProp="children"
                                                    options={this.senesorListStore?.assignAssetList}
                                                    filterOption={(input, option) => {
                                                        console.log(input)
                                                        if (!option?.vehicleNo) return false;

                                                        const label = option.vehicleNo
                                                            .toString()
                                                            .toLowerCase()
                                                            .replace(/\s+/g, "");

                                                        const search = input
                                                            .toLowerCase()
                                                            .replace(/\s+/g, "");

                                                        return label.includes(search);
                                                    }}
                                                />
                                            )}
                                        />
                                        <Column
                                            title={this.context.translate("_SENSOR_ID_")}
                                            dataIndex="sensorId"
                                            key="sensorId"
                                            width={100}
                                            render={(text, record, index) => (
                                                <Select
                                                    style={{ width: "150px" }}
                                                    value={text}
                                                    onSelect={async (e, f) => {
                                                        this.setState({ sensorId: e });
                                                        await this.handleInputChange(e, index, "sensorId");
                                                    }}
                                                    fieldNames={{
                                                        value: "sensorId",
                                                        label: "sensorId",
                                                    }}
                                                    optionFilterProp="children"
                                                    options={this.senesorListStore?.senesorList}
                                                />

                                            )}
                                        />
                                        <Column
                                            title={this.context.translate("_SENSOR_NAME_")}
                                            dataIndex="sensorName"
                                            key="sensorName"
                                            width={100}
                                            render={(text, record, index) => (
                                                <Input
                                                    value={text}
                                                    onChange={(e) => {
                                                        this.setState({ sensorName: e.target.value });
                                                        this.handleInputChange(e, index, "sensorName");
                                                    }}
                                                />
                                            )}
                                        />
                                        <Column
                                            title={this.context.translate("_TEMP_CALIBRATION_FACTOR_")}
                                            dataIndex="calibrationFactor"
                                            key="calibrationFactor"
                                            width={100}
                                            render={(text, record, index) => (
                                                <Input
                                                    value={text}
                                                    onChange={(e) => {
                                                        this.setState({ calibrationFactor: e.target.value });
                                                        this.handleInputChange(e, index, "calibrationFactor");
                                                    }}
                                                />
                                            )}
                                        />
                                        <Column
                                            title={this.context.translate("_HUMIDITY_CALIBRATION_FACTOR_")}
                                            dataIndex="humidityCalFactor"
                                            key="humidityCalFactor"
                                            width={100}
                                            render={(text, record, index) => (
                                                <Input
                                                    value={text}
                                                    onChange={(e) => {
                                                        this.setState({ humidityCalFactor: e.target.value });
                                                        this.handleInputChange(e, index, "humidityCalFactor");
                                                    }}
                                                />
                                            )}
                                        />
                                        <Column
                                            // title="Operation"
                                            title={this.context.translate("_OPERATION_")}
                                            dataIndex=""
                                            key=""
                                            width={100}
                                            render={(text, record, index) => (
                                                <div>
                                                    <Space>
                                                        <Link
                                                            onClick={() => {
                                                                this.onDeleteRow(index);
                                                            }}
                                                        >
                                                            <Tooltip
                                                                // title="Delete"
                                                                title={this.context.translate(
                                                                    "_FLEET_DASHBORD_RULETRIGGER_DELETE_"
                                                                )}
                                                                color={config.tooltipColorDelete}
                                                            >
                                                                <DeleteFilled
                                                                    style={{ color: config.deleteColor }}
                                                                />
                                                            </Tooltip>
                                                        </Link>
                                                    </Space>
                                                </div>
                                            )}
                                        />
                                    </Table>
                                </Col>
                            </Row>

                            <div className="formBtnGroup">
                                <Button
                                    className="formCancelButton"
                                    type="primary"
                                    onClick={(e) => {
                                        this.closeModal();
                                        // this.formRef.current?.resetFields();
                                    }}
                                >
                                    {this.context.translate("_FLEET_CLOSE_BTN_")}
                                </Button>
                                <Button
                                    type="primary"
                                    className="formSaveButton"
                                    htmlType="submit"
                                    loading={this.state.loading}
                                >
                                    {this.context.translate("_FLEET_DASHBORD_NEWPOI_SAVEBTN_")}
                                </Button>
                            </div>
                        </Form>
                    </Spin>
                </div>

            </div>
        );
    }
}



AddSensors.contextType = StoreContext;
export default observer(withRouter(AddSensors));
